import React, { useEffect, useMemo, useState } from "react";
import TakeActionCampaignContent from "../components/CampaignComponents/TakeActionCampaignContent";
import { useUser } from "../context/UserContext";
import { loadTakeActionDraftPreview } from "../utils/campaignDraftPreview";
import "../styles/component_styles/Campaigns.scss";

export default function TakeActionCampaignDraftPreviewPage() {
  const { verifiedUser } = useUser();
  const [draft, setDraft] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setDraft(loadTakeActionDraftPreview());
    setReady(true);
  }, []);

  const previewCampaign = useMemo(() => {
    if (!draft?.campaign) return null;
    return {
      ...draft.campaign,
      organizer_is_verified: Boolean(verifiedUser),
    };
  }, [draft, verifiedUser]);

  if (!ready) {
    return (
      <div className="take-action">
        <div className="campaign-loading">Loading preview...</div>
      </div>
    );
  }

  if (!previewCampaign) {
    return (
      <div className="take-action">
        <div className="take-action__empty">
          <h1>Preview unavailable</h1>
          <p>
            Click <strong>View</strong> on the Preview step while creating a campaign to open this page with
            your current draft. If you already did, refresh after saving — the preview is stored in your
            browser, not on the server.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="take-action take-action--draft-preview">
      <div className="take-action__draft-toolbar" role="status">
        Draft preview — this is what supporters will see on your take-action page. Close this tab when
        you&apos;re done reviewing.
      </div>
      <TakeActionCampaignContent
        mode="preview"
        campaign={previewCampaign}
        scheduleState="live"
        displayTargets={draft.displayTargets}
        callCompletions={0}
        emailCompletions={0}
        isLive
        suppressPreviewBanner
      />
    </div>
  );
}
